// Cookie utility functions

type CookieOptions = {
	maxAge?: number // in seconds
	path?: string
	sameSite?: 'Strict' | 'Lax' | 'None'
}

const DEFAULT_OPTIONS: CookieOptions = {
	maxAge: 31536000, // 1 year in seconds
	path: '/',
	sameSite: 'Strict',
}

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
	const opts = { ...DEFAULT_OPTIONS, ...options }
	const parts = [
		`${name}=${encodeURIComponent(value)}`,
		`path=${opts.path}`,
		`max-age=${opts.maxAge}`,
		`SameSite=${opts.sameSite}`,
	]
	document.cookie = parts.join('; ')
}

export const getCookie = (name: string): string | null => {
	const match = document.cookie.match(new RegExp(`(^|; )${name}=([^;]*)`))
	return match ? decodeURIComponent(match[2]) : null
}

export const deleteCookie = (name: string, path = '/'): void => {
	document.cookie = `${name}=; path=${path}; max-age=0`
}
